import React from "react";
import { auth } from "../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { Paper, Avatar, Typography, Stack } from '@mui/material';

// Utility function to calculate time ago
const timeAgo = (date) => {
  const seconds = Math.floor((new Date() - date) / 1000);

  // Check if the date represents a future time or very recent past
  if (seconds < 0) {
    return "now";
  }

  let interval = seconds / 31536000;
  if (interval > 1) {
    return Math.floor(interval) + " years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes ago";
  }
  return Math.floor(seconds) + " seconds ago";
};

const Message = ({ message, createdAt }) => {
  const [user] = useAuthState(auth);
  const sentTime = createdAt ? timeAgo(new Date(createdAt.toDate())) : "Unknown time";

  return (
    <Paper elevation={3} sx={{ padding: 1, bgcolor: message.uid === user.uid ? '#f55151' : '#303030', borderRadius: '10px', width:{ xs: '100%', sm: '50vw', md: '50vw', lg: '50vw' }}}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
            <Avatar src={message.avatar} alt="user avatar" />
            <Stack>
                <Typography variant="subtitle2">
                  <span style={{ fontSize: '0.8rem', fontWeight:"600"}}>{message.name}</span>
                  <span style={{ fontSize: '0.7rem', color: '#a83434', paddingLeft: '8px' }}>{sentTime}</span>
                </Typography>
                <Typography variant="body2" fontSize={14}>{message.text}</Typography>
            </Stack>
        </Stack>
    </Paper>
  );
};

export default Message;